import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Wait for config before starting React
const startApp = async () => {
  try {
    console.log('React waiting for config...');
    
    // Wait for config to load completely
    const config = await window.waitForConfig();
    
    console.log('React starting with config:', config);
    
    // Start React app
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );  
    
    reportWebVitals();
    
  } catch (error) {
    console.error('Failed to load config:', error);
    
    // Start anyway (config should have fallback)
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    
    reportWebVitals();
  }
};

// Start the app
startApp();